<template>
  <div class="card-plano position-relative">
    <div>
      <span
        class="recomend-span fs-12 font-weight-bold text-uppercase position-absolute"
        >Selecionado</span
      >
    </div>
    <div
      class="card-header position-relative text-uppercase font-weight-bold text-center fs-22"
    >
      <div class="checktainer c-c-initial m-0">Plano 1</div>
    </div>
    <div class="card-body">
      <div class="fs-28 text-center">R$ 49,90</div>
      <div class="fs-12 text-center">mensal + 1% da venda</div>
    </div>
    <div class="card-footer p-5px">
      <div
        class="w-100 c-pointer btn btn-aceitar-contrato"
        @click="showContratoPlano(contractId)"
      >
        Ver o contrato
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contractId: {
      required: true,
    },
  },
  methods: {
    showContratoPlano(contractId) {
      this.$bvModal.show(contractId);
    },
  },
};
</script>
